<script>
	import { onMount } from 'svelte';

	import NavListElement from '../../helpers/NavListElement.svelte';

	export let meta;
	export let html;
	
	let companyName = '';
	let companyAddress = '';
	let companyPhone = '';
	let companyMail = '';
	
	function fromMeta(field) {
		return Array.from(meta).filter(_meta => _meta.getAttribute('name').toLowerCase() === field.toLowerCase())[0];
	}
	
	onMount(() => {
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;
		meta = tempDiv.querySelectorAll('.meta');
		companyName = fromMeta('companyName')?.getAttribute('content') || companyName;
		companyAddress = fromMeta('companyAddress')?.getAttribute('content') || companyAddress;
		companyPhone = fromMeta('companyPhone')?.getAttribute('content') || companyPhone;
		companyMail = fromMeta('companyMail')?.getAttribute('content') || companyMail;
	});

	let portfolioString = 'portfolio';
</script>

<div class="linkwall">
	<ul>
		<li>{@html companyName}</li>
		<li>{@html companyAddress}</li>
		<li class="tel">
			<span>
				<a href="tel: {companyPhone}">{@html companyPhone}</a>
			</span>
		</li>
		{#if companyMail}
			<li class="tel">
				<span>
					<a href="mailto: {companyMail}">{@html companyMail}</a>
				</span>
			</li>
		{/if}
	</ul>
	<ul>
		<NavListElement url="agentur" text="Agentur"/>
		<NavListElement url="agentur/kontakt" text="Kontakt"/>
		<NavListElement url="agentur/jobs" text="Jobs"/>
		<NavListElement extraClass="visible--mobile" url="impressum" text="Impressum"/>
		<NavListElement extraClass="visible--mobile" url="datenschutz" text="Datenschutz"/>
	</ul>
	<ul>
		<NavListElement url="expertise_design" text="Expertise"/>
		<NavListElement url="expertise_design" text="Design"/>
		<NavListElement url="expertise_technologie" text="Technologie"/>
	</ul>
	<ul>
		<NavListElement url={portfolioString} text="Portfolio"/>
		<NavListElement url={`${portfolioString}/appetit_digitalisieren`} text="Appetit digitalisieren"/>
		<NavListElement url={`${portfolioString}/ueberflieger`} text="Überflieger"/>
		<NavListElement url={`${portfolioString}/menschen_bewegen`} text="Menschen bewegen"/>
		<NavListElement url={`${portfolioString}/stream_on`} text="Stream On"/>
		<NavListElement url={`${portfolioString}/weltweit_regional`} text="weltweit regional"/>
		<NavListElement url={`${portfolioString}/kein_mittelmass`} text="Kein Mittelmaß"/>
		<NavListElement url={`${portfolioString}/individuelle_klasse`} text="individuell(e) Klasse"/>
		<NavListElement url={`${portfolioString}/health_and_care`} text="Health & Care"/>
		<NavListElement url={`${portfolioString}/burgeins_stromert`} text="BurgEins stromert"/>
		<NavListElement url={`${portfolioString}/opel_case_study`} text="Opel Case Study"/>
		<NavListElement url={`${portfolioString}/aes_hub`} text="AES HUB"/>
	</ul>
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";

	.linkwall {
		width: 100%;
		background-color: #ffffff;
		color: var(--color-burgeins-2);
		display: flex;
		padding: calc(var(--spacing-mobile) * 1.8) var(--spacing-mobile);
		flex-wrap: wrap;
		line-height: 1.5em;
		position: relative;
		// negative margin, as the surrounding div is a grid with given gap:
		margin-bottom: calc(-1 * var(--li-gap));

		&:after {
			content: "";
			display: block;
			position: absolute;
			top: 0;
			height: 100%;
			width: 100vw;
			background-color: inherit;
			z-index: -1;
		}

		@include for-tablet-portrait-up {
			gap: px-to-em(20);
			justify-content: center;
		}
		@include for-tablet-landscape-up {
			flex-wrap: nowrap;
			line-height: 1.3em;
		}

		a {
			border-bottom: 1px solid var(--color-burgeins-2);
		}

		ul {
			flex: auto;
			list-style-type: none;
			width: 60%;
			margin-bottom: var(--spacing-mobile);

			@include for-tablet-portrait-up {
				width: auto;
				max-width: max-content;
			}

			@include for-desktop-up {
				&:first-of-type li {
					font-size: 2.5rem;
					line-height: 4rem;
				}
			}

			li {
				line-height: 3rem;

				&:first-of-type {
					font-weight: 600;
					color: black;

					@include for-tablet-landscape-up {
						padding-bottom: calc(var(--spacing-tablet) / 3);
					}

					div a:first-of-type {
						font-weight: 600;
						text-decoration: none;

					}

					div a {
						border-bottom: none;
					}

					span {
						font-weight: 300;
						font-style: italic;
						color: var(--color-burgeins-2);
					}
				}
			}

			&:first-of-type {
				li:first-of-type {
					color: black;
					font-style: normal;
					padding-bottom: 0;

					@include for-tablet-landscape-up {
						padding-bottom: calc(var(--spacing-tablet) / 3);
					}
				}
			}

			:global(li.tel span),
			:global(li.email span) {
				border-bottom: 1px solid var(--color-burgeins-2);
			}
		}
	}

	:global(.useCustomCss) .linkwall {
		color: #ffffff;
		background-color: #000;

		ul {
			li {
				color: rgba(255, 255, 255, 0.65);
				transition: color .2s ease-in-out;
			}

			li .active, li :hover {
				color: white !important;
			}

			li:first-of-type {
				color: #ffffff;
			}
		}
	}
</style>
